'use strict';

var otppConfig = angular.module('otpp-config', []);

otppConfig.constant('otppConstants', {
  apiUrl: '/members/my/api/members',
  cmsUrl: '/members/cms',
  skipOutageKey: 'skipoutage',
  tokenStorageKey: 'mbr.token',
  mbrAuthKey: 'mbr.auth',
  bamKey: 'bam',
  accountHashKey: 'mbr.accountHash',
  localeFiles: '/members/my/resources/lang/locale/',
  analyticsKey: 'aa',
  authCallbackDestinationKey: 'authCallbackDestination'
});

otppConfig.constant('toggleConfig', (function() {
  if (window.OTPP && window.OTPP.ft) {
    return window.OTPP.ft;
  } else {
    return {toggles: {}};
  }
})());
